import fetch from '../utils/fetch'

import { BASE_URL } from './constants'

export const createRecord = (record) => {
  return fetch(`${BASE_URL}/create-warehouse-record/`, {
    method: 'POST',
    body: JSON.stringify(record)
  })
}

export const retrieveUnlinkedWarehouseRecords = () => {
  return fetch(`${BASE_URL}/retrieve-unlinked-warehouse-records/`)
}

export const getWarehouseRecordById = (id) => {
  return fetch(`${BASE_URL}/get-warehouse-record-by-id/${id}`)
}

export const linkWarehouseRecord = (linkContent) => {
  return fetch(`${BASE_URL}/link-warehouse-record/`, {
    method: 'POST',
    body: JSON.stringify(linkContent)
  })
}

export const deleteWarehouseRecord = (entityId) => {
  return fetch(`${BASE_URL}/delete-warehouse-record/`, {
    method: 'POST',
    body: JSON.stringify({entityId})
  })
}

export const deleteInventoryItem = (inventoryItem) => {
  return fetch(`${BASE_URL}/undo-stockin/`, {
    method: 'PUT',
    body: JSON.stringify(inventoryItem)
  })
}



// WEBPACK FOOTER //
// ./src/services/warehouseServices.js